/**
 * UpdatedStamp - the italic "Updated · 18 Apr 2026" data-provenance stamp.
 * Renders NOTHING when no real date exists: fabricating a timestamp is a
 * house-rule violation, so absence of data means absence of the stamp.
 */
import React from 'react';
import { Typography } from '@mui/material';
import { useThemeMode } from '../../context/ThemeContext';
import { fmtDate } from '../../utils/format';

function UpdatedStamp({ date, prefix = 'Updated', component = 'p', sx }) {
  const { palette } = useThemeMode();
  if (!date) return null;
  const label = fmtDate(date);
  if (label === '-') return null;
  return (
    <Typography
      component={component}
      sx={{ fontSize: '0.62rem', color: palette.textMuted, fontStyle: 'italic', letterSpacing: '0.02em', ...sx }}
    >
      {prefix} · {label}
    </Typography>
  );
}

export default UpdatedStamp;
